"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDealerIdEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const InventoryDealerIdDto_1 = require("./InventoryDealerIdDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class InventoryDealerIdEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, inventoryDealerId) {
        super();
        this._requiredFieldsSetStatus = {
            value: false,
            inventoryProviderId: false
        };
        this._dependencies = dependencies;
        if (inventoryDealerId === undefined) {
            this._dto = new InventoryDealerIdDto_1.InventoryDealerIdDto();
        }
        else if (inventoryDealerId instanceof InventoryDealerIdDto_1.InventoryDealerIdDto) {
            this._dto = new InventoryDealerIdDto_1.InventoryDealerIdDto(inventoryDealerId);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (inventoryDealerId instanceof InventoryDealerIdEntity) {
            this._dto = new InventoryDealerIdDto_1.InventoryDealerIdDto(inventoryDealerId._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new InventoryDealerIdDto_1.InventoryDealerIdDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getValue() {
        return this._dto.value;
    }
    setValue(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("value");
        this._requiredFieldsSetStatus.value = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("value", "Value is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("value", `Value has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.value) {
            return;
        }
        this._dto.value = _untrustedValue;
        this._setIsDirty(true);
    }
    getInventoryProviderId() {
        return this._dto.inventoryProviderId;
    }
    setInventoryProviderId(untrustedValue) {
        let _untrustedValue;
        this.clearError("inventoryProviderId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("inventoryProviderId", "Inventory Provider Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.inventoryProviderId) {
            return;
        }
        this._dto.inventoryProviderId = _untrustedValue;
        this._setIsDirty(true);
    }
    getFlickFusionId() {
        return this._dto.flickFusionId;
    }
    setFlickFusionId(untrustedValue) {
        let _untrustedValue;
        this.clearError("flickFusionId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("flickFusionId", "Parent InventoryDealerId Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.flickFusionId) {
            return;
        }
        this._dto.flickFusionId = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.inventoryDealerIdDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("InventoryDealerId is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.inventoryDealerIdDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.inventoryDealerIdDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("InventoryDealerId cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.inventoryDealerIdDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.InventoryDealerIdEntity = InventoryDealerIdEntity;
//# sourceMappingURL=InventoryDealerIdEntity.js.map